import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index";

// Lazy load non-homepage routes
const NotFound = lazy(() => import("./pages/NotFound"));
const AIDevelopment = lazy(() => import("./pages/services/AIDevelopment"));
const AIAgents = lazy(() => import("./pages/services/AIAgents"));
const EcommerceDevelopment = lazy(() => import("./pages/services/EcommerceDevelopment"));
const PaymentGateways = lazy(() => import("./pages/services/PaymentGateways"));
const CustomDevelopment = lazy(() => import("./pages/services/CustomDevelopment"));
const CustomTools = lazy(() => import("./pages/services/CustomTools"));
const WordPressWooCommerce = lazy(() => import("./pages/services/WordPressWooCommerce"));
const PostLaunchSupport = lazy(() => import("./pages/services/PostLaunchSupport"));
const LaravelDevelopment = lazy(() => import("./pages/services/LaravelDevelopment"));
const ShopifyDevelopment = lazy(() => import("./pages/services/ShopifyDevelopment"));
const MobileDevelopment = lazy(() => import("./pages/services/MobileDevelopment"));
const CaseStudies = lazy(() => import("./pages/CaseStudies"));
const CaseStudyDetail = lazy(() => import("./pages/CaseStudyDetail"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/services/ai-development" element={<AIDevelopment />} />
            <Route path="/services/ai-agents" element={<AIAgents />} />
            <Route path="/services/ecommerce-development" element={<EcommerceDevelopment />} />
            <Route path="/services/payment-gateways" element={<PaymentGateways />} />
            <Route path="/services/custom-development" element={<CustomDevelopment />} />
            <Route path="/services/custom-tools" element={<CustomTools />} />
            <Route path="/services/wordpress-woocommerce" element={<WordPressWooCommerce />} />
            <Route path="/services/post-launch-support" element={<PostLaunchSupport />} />
            <Route path="/services/laravel-development" element={<LaravelDevelopment />} />
            <Route path="/services/shopify-development" element={<ShopifyDevelopment />} />
            <Route path="/services/mobile-development" element={<MobileDevelopment />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;